import { useAuthState } from "react-firebase-hooks/auth";
import { Outlet, Navigate } from "react-router-dom";

import { auth } from "../firebase/firebase";

import MainLoader from "../shared/MainLoader";

type ProtectedRoutesProps = {
  isTokenLoaded: boolean;
};

const ProtectedRoutes = ({ isTokenLoaded }: ProtectedRoutesProps) => {
  const [user] = useAuthState(auth);
  if (user && isTokenLoaded) return <Outlet />;
  else if (user && !isTokenLoaded) return <MainLoader />;
  else return <Navigate to={""} />;
};

export default ProtectedRoutes;
